import Vue from 'vue'
import vuetifyNsuk from '../plugins/vuetify'
import AppNsuk from './nsuk/App.vue'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import NotificationPlugin from '../plugins/notify';
import urlUtil from "@/utils/urlUtil";

// set default api
axios.defaults.baseURL = urlUtil.getBaseUrl();


Vue.config.productionTip = false;
Vue.use(NotificationPlugin)
Vue.use(VueToast);

new Vue({
  vuetify: vuetifyNsuk,
  render: h => h(AppNsuk)
}).$mount('#app')
